import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import noMessageIcon from '../../assets/Images/no-aims.png';
import { useStore } from '../../contexts/store-provider';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Header from '../../shared-components/header/header';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';
import { formatMessage } from '../../translations/format-message';
import './aims-portal.css';
import AddAIMSPortal from './components/add-edit-aims-portal';
import AIMSPortalPopupHOC from './hoc/add-portal-popup-hoc';

const AIMSPortal = (props: any) => {
  const { aimsPortalStore, preferencesStore } = useStore();
  const {
    GetPortalListService,
    getAllPortalState,
    allAvailablePortals,
    addUpdatePortalState,
    resetAddUpdatePortalState,
  } = aimsPortalStore;
  const { language, islanguageChanged, updateLanguageChangedFlag } =
    preferencesStore;
  let lang: string;
  const allPortalListData = allAvailablePortals;

  const getPortalListServiceHandler = () => {
    GetPortalListService();
  };

  useEffect(() => {
    getPortalListServiceHandler();
  }, []);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    if (lang && language !== lang) {
      getPortalListServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (addUpdatePortalState.success) {
      resetAddUpdatePortalState();
      getPortalListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdatePortalState.success]);

  return (
    <>
      {' '}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <Header className='col-lg-6 col-md-6 col-sm-6' label="aims_title" />
        </div>
      </div>
      <div className="card card-page">
        {getAllPortalState.inProgress && (
          <FormLoader loading={getAllPortalState.inProgress} />
        )}
        {allPortalListData && allPortalListData.length > 0 ? (
          <>
            <div>
              <div className="tableDesign changingPanel height-page aims-page">
                <div data-testid="table">
                  <AddAIMSPortal templates={allPortalListData} />
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="message">
            <div className="d-flex message-area">
              <div className="no-data-img">
                <img
                  src={noMessageIcon}
                  alt=""
                  className="no_message"
                />
              </div>
              <div>
                <h3 className="fw-bold display-6">
                  {' '}
                  <FormattedMessage id="no_portal" />
                </h3>
                <h4 className="mb-3">{formatMessage('no_portal_message')}</h4>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default FilterPopupHOC(
  AIMSPortalPopupHOC(DeletePopupHOC(observer(AIMSPortal)))
);
